/**
 * The media chooser used inside the editors (spec 003): a read-only listing
 * with folders, search, sort, the caller's type filter and upload into the
 * folder being browsed. No delete, rename, move or folder management.
 * Click selects, double-click picks, "Choose" picks the selection.
 */
import { useCallback, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import MediaList from '../components/MediaList';
import { MediaTypeFilter } from '@shared/@types';
import type { MediaItem } from '../@types/Media';

export interface MediaPickerProps {
  typeFilter?: MediaTypeFilter;
  lockFilter?: boolean;
  /** Called once with the picked media id and, when listed, its item (its length, spec 041). */
  onSelect: (mediaId: number, item?: MediaItem) => void;
  onCancel: () => void;
}

const MediaPicker = ({ typeFilter, lockFilter = false, onSelect, onCancel }: MediaPickerProps) => {
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [selectedItem, setSelectedItem] = useState<MediaItem | undefined>(undefined);
  const onSelectionChange = useCallback((id: number | null, item?: MediaItem) => {
    setSelectedId(id);
    setSelectedItem(item);
  }, []);

  return (
    <>
      <MediaList
        mode="picker"
        typeFilter={typeFilter}
        lockFilter={lockFilter}
        onSelectionChange={onSelectionChange}
        onPick={onSelect}
      />
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" disabled={selectedId === null} onClick={() => selectedId !== null && onSelect(selectedId, selectedItem)}>
          Choose
        </Button>
      </Modal.Footer>
    </>
  );
};

export default MediaPicker;
